import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'

const ContainerVoucherData = props => {
  return (
    <div className={props.classes.voucherLines}>
      <div className={props.classes.voucherLinesInfo}>
        <Grid container>
          <Grid item xs={8}>
            <Typography className={props.classes.voucherLinesText}>Tipo de envase</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography className={props.classes.voucherLinesTextRight}>Entrega</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography className={props.classes.voucherLinesTextRight}>Retira</Typography>
          </Grid>
        </Grid>
        {props.lines.map((line, index) => (
          <Grid key={index} container>
            <Grid item xs={8}>
              <Typography className={props.classes.voucherLinesTextBold}>{line.container_name}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography className={props.classes.voucherLinesTextBoldRight}>{parseFloat(line.entrega).toLocaleString(undefined, {maximumFractionDigits: 0})}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography className={props.classes.voucherLinesTextBoldRight}>{parseFloat(line.retira).toLocaleString(undefined, {maximumFractionDigits: 0})}</Typography>
            </Grid>
          </Grid>
        ))}
      </div>
      {(props.vehicle_plate || props.trailer_plate) && (
        <div className={props.classes.voucherLinesInfo}>
          <Grid container>
            {props.vehicle_plate && (
              <Grid item xs={6} className={props.classes.voucherLinesInfoStart}>
                <Typography className={props.classes.voucherLinesText}>Vehículo: </Typography>
                <Typography className={props.classes.voucherLinesTextBold}>{props.vehicle_plate}</Typography>
              </Grid>
            )}
            {props.trailer_plate && (
              <Grid item xs={6} className={props.classes.voucherLinesInfoStart}>
                <Typography className={props.classes.voucherLinesText}>Remolque</Typography>
                <Typography className={props.classes.voucherLinesTextBold}>{props.trailer_plate}</Typography>
              </Grid>
            )}
          </Grid>
        </div>
      )}
      {(props.observations1 || props.observations2) && (
        <div className={props.classes.voucherLinesInfo}>
          <Grid container>
            <Grid item xs={12}>
              <Typography className={props.classes.voucherLinesText}>Observaciones</Typography>
              <Typography className={props.classes.voucherLinesTextBold}>{props.observations1}</Typography>
              <Typography className={props.classes.voucherLinesTextBold}>{props.observations2}</Typography>
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  )
}

const styles = {
  voucherLines: {
    margin: '10px 0',
    background: 'white',
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.17)',
    borderRadius: 4
  },
  voucherLinesInfo: {
    padding: 10
  },
  voucherLinesInfoStart: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center'
  },
  voucherLinesText: {
    fontSize: 12,
    fontWeight: 300,
    lineHeight: '16px'
  },
  voucherLinesTextRight: {
    fontSize: 12,
    fontWeight: 300,
    lineHeight: '16px',
    textAlign: 'right'
  },
  voucherLinesTextBold: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '14px'
  },
  voucherLinesTextBoldRight: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '14px',
    textAlign: 'right'
  }
}

export default withStyles(styles)(ContainerVoucherData)



// WEBPACK FOOTER //
// ./src/components/ContainerVoucherData.js